import {createSelector} from 'reselect';

export const getAnnotationsSlice = (state) => state.annotations;

export const getAnnotationsSliceByIdSlice = createSelector(
	[getAnnotationsSlice],
	(annotationsSlice) => annotationsSlice.byId
);

export const getAnnotationsSliceIds = createSelector(
	[getAnnotationsSlice],
	(annotationsSlice) => annotationsSlice.allIds
);

export const getAnnotationsSliceById = createSelector(
	[getAnnotationsSliceByIdSlice, (state, annotationId) => annotationId],
	(byIdSlice, annotationId) => byIdSlice[annotationId]
);

export const getAnnotationById = (annotationId) => {
	return createSelector([getAnnotationsSliceByIdSlice], (annotations) => annotations[annotationId]);
};
